import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import MainSearchAPI from '../../../api/MainSearchAPI';

class FieldMultiSelect extends React.Component {
  state = {
    selectedOptions: [],
  };

  componentDidMount() {
    this.updateSelectedOptions(this.props.value);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.updateSelectedOptions(this.props.value);
    }
  }

  updateSelectedOptions = (values) => {
  const cleaned = (values || []).filter(v => v !== null && v !== undefined && v !== '');
  if (cleaned.length === 0) {
    this.setState({ selectedOptions: [] });
    return;
  }
 const allResolved = cleaned.every(v => typeof v === "object");
  if (allResolved) {
    this.setState({ selectedOptions: cleaned });
    return;
  }
  const fetchPromises = values.map((v) => {
    if (typeof v === "object") return Promise.resolve(v);
    return new Promise((resolve) => {
      MainSearchAPI.propertySearch(v, (res) => {
        if (res && res.length > 0) {
          resolve({ value: res[0].id, label: res[0].name });
        } else {
          resolve({ value: Number(v), label: String(v) });
        }
      }, () => resolve({ value: Number(v), label: String(v) }));
    });
  });

  Promise.all(fetchPromises).then((options) => {
    this.setState({ selectedOptions: options });
    this.props.onValueChange(this.props.id, options);
    });
  };

  loadPropertyOptions = (inputValue, callback) => {
    if (!inputValue || inputValue.length < 2) return callback([]);
    MainSearchAPI.propertySearch(inputValue, (res) => {
      const options = res.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      callback(options);
    });
  };

  render() {
    const { id: key, field, visible, editable, mandatory, error, errorMessage, options } = this.props;
    const { selectedOptions } = this.state;

    if (!visible || !editable) return null;

    const isPropertyField = field.field_key === "property";

    return (
      <div className="col">
        <div className="form-group">
          <label>
            {field.label_name}
            {mandatory && <span className="required-field" />}
          </label>
          {error && <label className="error-w">{errorMessage}</label>}

          {isPropertyField ? (
            <AsyncSelect
              value={selectedOptions}
              loadOptions={this.loadPropertyOptions}
              onChange={(selections) => this.props.onValueChange(key, selections)}
              isDisabled={!editable}
              isSearchable
              isClearable
              isMulti
              defaultOptions
              cacheOptions
              placeholder="Search for properties..."
            />
          ) : (
            <Select
              value={selectedOptions}
              onChange={(selections) => this.props.onValueChange(key, selections)}
              options={options.filter((option) => option.visible)}
              isDisabled={!editable}
              isSearchable
              isClearable
              isMulti
            />
          )}
        </div>
      </div>
    );
  }
}

export default FieldMultiSelect;

